import type { IModule } from '@core/infrastructure/serviceContainer/types';

export const productModule: IModule = {
	providers: [],
};
